import { parseFromStripe } from "./parseFromStripe";

const today = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 4902,
    amount_paid: 0,
    amount_remaining: 4902,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1694421832,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [
        {
            id: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            object: "tax_rate",
            active: true,
            country: "MY",
            created: 1693369528,
            description: "SST",
            display_name: "Sales tax",
            effective_percentage: 6.0,
            inclusive: false,
            jurisdiction: null,
            livemode: false,
            metadata: {},
            percentage: 6.0,
            state: null,
            tax_type: null,
        },
    ],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_127758GSTSE9ZxBo4a0e5edb",
                object: "line_item",
                amount: -3557,
                amount_excluding_tax: -3557,
                currency: "myr",
                description: "Unused time on Subscription (Monthly) after 10 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1Np5imGSTSE9ZxBobM9fhj7F",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1694361600,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 5900,
                    amount_decimal: "5900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "inclusive",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 5900,
                    unit_amount_decimal: "5900",
                },
                proration: true,
                proration_details: {
                    credited_items: {
                        invoice: "in_1NkNMiGSTSE9ZxBoFc7Ff9ld",
                        invoice_line_items: [
                            "il_1NkNMiGSTSE9ZxBoSy2zspKO",
                        ],
                    },
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OXSHx7ZMeCK8Mf",
                tax_amounts: [
                    {
                        amount: -213,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: -3557,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "-3557",
            },
            {
                id: "il_tmp_198a1dGSTSE9ZxBo3048c568",
                object: "line_item",
                amount: 898,
                amount_excluding_tax: 898,
                currency: "myr",
                description: "Remaining time on Data Extraction Top Up after 10 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1Np5imGSTSE9ZxBo0ex3gDsc",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1694361600,
                },
                plan: {
                    id: "price_1NhlAtGSTSE9ZxBoP9s3Jzr8",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692674555,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkgjOycFADY51",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlAtGSTSE9ZxBoP9s3Jzr8",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674555,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkgjOycFADY51",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: true,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OcKNyDjACMZDJv",
                tax_amounts: [
                    {
                        amount: 54,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 898,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "898",
            },
            {
                id: "il_tmp_17f27eGSTSE9ZxBob2147ae4",
                object: "line_item",
                amount: 898,
                amount_excluding_tax: 898,
                currency: "myr",
                description: "Remaining time on WhatsApp File Top Up after 10 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1Np5imGSTSE9ZxBoBE5c64gW",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1694361600,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: true,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OcKNA5GfVu9Jow",
                tax_amounts: [
                    {
                        amount: 54,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 898,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "898",
            },
            {
                id: "il_tmp_132163GSTSE9ZxBo4dd6ef30",
                object: "line_item",
                amount: 416,
                amount_excluding_tax: 416,
                currency: "myr",
                description: "Remaining time on Email Top Up after 10 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1Np5imGSTSE9ZxBoVo1Iarfp",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1694361600,
                },
                plan: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: true,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OcKNMlQz9XjLZB",
                tax_amounts: [
                    {
                        amount: 25,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 416,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "416",
            },
            {
                id: "il_tmp_1f4b4fGSTSE9ZxBo07d40c96",
                object: "line_item",
                amount: 5969,
                amount_excluding_tax: 5969,
                currency: "myr",
                description: "Remaining time on Subscription (Monthly) after 10 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1Np5imGSTSE9ZxBoc4WuL940",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1694361600,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 9900,
                    amount_decimal: "9900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 9900,
                    unit_amount_decimal: "9900",
                },
                proration: true,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OcKNrEDRC8En75",
                tax_amounts: [
                    {
                        amount: 358,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 5969,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "5969",
            },
        ],
        has_more: false,
        total_count: 5,
        url: "/v1/invoices/upcoming/lines?subscription=sub_1NkNMiGSTSE9ZxBoRpjxTwNC&subscription_proration_date=1694361600&subscription_proration_behavior=always_invoice&subscription_default_tax_rates%5B%5D=txr_1Nkfy8GSTSE9ZxBoFANix2G3&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OXSHx7ZMeCK8Mf&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B3%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoY5RZTJkp&subscription_items%5B3%5D%5Bquantity%5D=1&subscription_items%5B3%5D%5Bdeleted%5D=false&subscription_items%5B4%5D%5Bprice%5D=price_1NhlAtGSTSE9ZxBoP9s3Jzr8&subscription_items%5B4%5D%5Bquantity%5D=1&subscription_items%5B4%5D%5Bdeleted%5D=false&subscription_items%5B1%5D%5Bprice%5D=price_1LYQytGSTSE9ZxBop8hNIMcD&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bquantity%5D=1&subscription_items%5B2%5D%5Bprice%5D=price_1NhlI2GSTSE9ZxBo2zfnO7Rw&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1694421832,
    period_start: 1693298016,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1694361600,
    subtotal: 4624,
    subtotal_excluding_tax: 4624,
    tax: 278,
    test_clock: null,
    total: 4902,
    total_discount_amounts: [],
    total_excluding_tax: 4624,
    total_tax_amounts: [
        {
            amount: 278,
            inclusive: false,
            tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            taxability_reason: null,
            taxable_amount: 4624,
        },
    ],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const nextNoProration = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 13570,
    amount_paid: 0,
    amount_remaining: 13570,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1695976416,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_1bf104GSTSE9ZxBo94752760",
                object: "line_item",
                amount: 9900,
                amount_excluding_tax: 9900,
                currency: "myr",
                description: "1 × Subscription (Monthly) (at RM99.00 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698568416,
                    start: 1695976416,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 9900,
                    amount_decimal: "9900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 9900,
                    unit_amount_decimal: "9900",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OcdRtJDRXkmRnL",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "9900",
            },
            {
                id: "il_tmp_1583b1GSTSE9ZxBo40561144",
                object: "line_item",
                amount: 690,
                amount_excluding_tax: 690,
                currency: "myr",
                description: "1 × Email Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698568416,
                    start: 1695976416,
                },
                plan: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OcdR9gDYxD8R6Y",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
            {
                id: "il_tmp_111875GSTSE9ZxBo2be6e4b4",
                object: "line_item",
                amount: 1490,
                amount_excluding_tax: 1490,
                currency: "myr",
                description: "1 × WhatsApp File Top Up (at RM14.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698568416,
                    start: 1695976416,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OcdRidI6ITv2Lk",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "1490",
            },
            {
                id: "il_tmp_18ae44GSTSE9ZxBo986381a2",
                object: "line_item",
                amount: 1490,
                amount_excluding_tax: 1490,
                currency: "myr",
                description: "1 × Data Extraction Top Up (at RM14.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698568416,
                    start: 1695976416,
                },
                plan: {
                    id: "price_1NhlAtGSTSE9ZxBoP9s3Jzr8",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692674555,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkgjOycFADY51",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlAtGSTSE9ZxBoP9s3Jzr8",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674555,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkgjOycFADY51",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OcdRJQqe81P1q8",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "1490",
            },
        ],
        has_more: false,
        total_count: 4,
        url: "/v1/invoices/upcoming/lines?subscription=sub_1NkNMiGSTSE9ZxBoRpjxTwNC&subscription_proration_behavior=none&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OXSHx7ZMeCK8Mf&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B3%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoY5RZTJkp&subscription_items%5B3%5D%5Bquantity%5D=1&subscription_items%5B3%5D%5Bdeleted%5D=false&subscription_items%5B4%5D%5Bdeleted%5D=false&subscription_items%5B4%5D%5Bquantity%5D=1&subscription_items%5B4%5D%5Bprice%5D=price_1NhlAtGSTSE9ZxBoP9s3Jzr8&subscription_items%5B1%5D%5Bprice%5D=price_1LYQytGSTSE9ZxBop8hNIMcD&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bprice%5D=price_1NhlI2GSTSE9ZxBo2zfnO7Rw&subscription_items%5B2%5D%5Bquantity%5D=1&subscription_items%5B2%5D%5Bdeleted%5D=false&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: 1695980016,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1695976416,
    period_start: 1693298016,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1694492757,
    subtotal: 13570,
    subtotal_excluding_tax: 13570,
    tax: null,
    test_clock: null,
    total: 13570,
    total_discount_amounts: [],
    total_excluding_tax: 13570,
    total_tax_amounts: [],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const SameCycleUpgrade = parseFromStripe(today);
const NoProration = parseFromStripe(nextNoProration);

export const SameCycleUpgradeExpected = {
    today: SameCycleUpgrade,
    next: NoProration,
};

// export const SameCycleUpgradePreviewInvoice = {
//     subtotal: 46.24,
//     discount_amount: 0,
//     total_excluding_tax: 46.24,
//     tax_amount: 2.78,
//     total: 49.02,
//     amount_due: 49.02,
//     billing_cycle: 1, // from recurring.interval_count
//     // billing_anchor_date: '2023-09-11 00:00:00',
//     proration_start_date: '2023-09-11 00:00:00', // from lines.data.start_date
//     proration_end_date: '2023-09-29 16:33:36', // from lines.data.end_date
//     first_billing_date: '2023-09-11 00:00:00', // from created (try with always_invoice vs create_prorations)
//     prices: [
//         {
//             description: "Unused time on Subscription (Monthly) after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 59,
//             amount: -35.57,
//             amount_excluding_tax: -35.57,
//             product_name: "Growth",
//         },
//         {
//             description: "Remaining time on Data Extraction Top Up after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 14.9,
//             amount: 8.98,
//             amount_excluding_tax: 8.98,
//             product_name: "Data Extraction Top Up",
//         },
//         {
//             description: "Remaining time on WhatsApp File Top Up after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 14.9,
//             amount: 8.98,
//             amount_excluding_tax: 8.98,
//             product_name: "WhatsApp File Top Up",
//         },
//         {
//             description: "Remaining time on Email Top Up after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 6.9,
//             amount: 4.16,
//             amount_excluding_tax: 4.16,
//             product_name: "Email Top Up",
//         },
//         {
//             description: "Remaining time on Subscription (Monthly) after 10 Sep 2023",
//             quantity: 1,
//             start_time: '2023-09-11 00:00:00',
//             end_time: '2023-09-29 16:33:36',
//             plan_unit_amount: 99,
//             amount: 59.69,
//             amount_excluding_tax: 59.69,
//             product_name: "Premium",
//         },
//     ],
// };
